import posthog from 'posthog-js'

/** The page's PostHog events; `insure_fill_application_customer_link_opened` is sent from `/quotes` when a staff link lands (Phase 6 Task 6.5a). */
export enum FillApplicationEvent {
  OPENED = 'insure_fill_application_opened',
  FILES_DROPPED = 'insure_fill_application_files_dropped',
  PARSE_FINISHED = 'insure_fill_application_parse_finished',
  SEND_BLOCKED = 'insure_fill_application_send_blocked',
  SENT = 'insure_fill_application_sent',
  CUSTOMER_LINK_COPIED = 'insure_fill_application_customer_link_copied',
  VIEW_ONLY_LINK_COPIED = 'insure_fill_application_view_only_link_copied',
}

export function trackFillApplication(
  event: FillApplicationEvent,
  properties: Record<string, unknown> = {}
): void {
  // posthog.init only runs in production; capture on an uninitialised client logs an error per call.
  if (!posthog.__loaded) return
  posthog.capture(event, properties)
}
